Ext.define('SA.model.ObservableChangeMixin', {
    setWithEvent(values, event) {
        var changed = false;

        if (typeof values === 'string') {
            this.setWithEvent(SA.createObject(values, event), 'set:' + values);

            return;
        }

        Object.entries(values).forEach(([field, value]) => {
            if (value !== this.get(field)) {
                changed = true;
                this.set(field, value);
            }
        });

        if (changed) {
            this.fireEvent(event, this);
        }
    }
});